var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-3" },
          [
            _c("template-draft-listing", {
              on: {
                "template-selected": function($event) {
                  _vm.previewedTemplateId = $event
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.showBuilderTemplates
          ? _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("template-primary-listing", {
                  on: {
                    "template-selected": function($event) {
                      _vm.previewedTemplateId = $event
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showPublishableTemplates
          ? _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("template-publishable-listing", {
                  on: {
                    "template-selected": function($event) {
                      _vm.previewedTemplateId = $event
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.previewedTemplateId
          ? _c(
              "div",
              { staticClass: "col" },
              [
                _c("template-preview", {
                  attrs: { "template-id": _vm.previewedTemplateId }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }